import { safeDisplayText } from '../utils/pdnDisplay'
import { apiRequest } from './client'
import type { MeResponse } from './types'

// Терпимость к обоим написаниям на проводе: API нормализуется к snake_case,
// поэтому читаем camelCase, а при его отсутствии — snake_case.
type MeRaw = MeResponse & {
  display_name?: string
}

const sanitizeOptionalName = (value: string | null | undefined): string | null => {
  if (value == null) {
    return null
  }
  const trimmed = value.trim()
  if (!trimmed) {
    return null
  }
  const safe = safeDisplayText(trimmed, '')
  return safe || null
}

const normalizeMe = (raw: MeRaw): MeResponse => {
  const rawName = raw.displayName ?? raw.display_name ?? ''
  return {
    ...raw,
    displayName: safeDisplayText(rawName, ''),
    email: safeDisplayText(raw.email, ''),
    organizations: (raw.organizations ?? []).map((org) => ({
      ...org,
      legal_name: safeDisplayText(org.legal_name, `Организация #${org.id}`),
      trade_name: sanitizeOptionalName(org.trade_name),
    })),
  }
}

export const fetchMe = () => apiRequest<MeRaw>('/me').then(normalizeMe)
